export default "<template>\n\n  <KButton\n    text=\"Icon After\"\n    iconAfter=\"video\"\n  />\n\n</template>\n";